import { useMutation, useQueryClient } from "@tanstack/vue-query";

import { InternalMutationKeys } from "@/data/api/kili/internal/internal-query-keys";
import KiliApi from "@/data/api/kili/kili-api";
import { SitesQueryKeys } from "@/data/api/kili/sites/sites-query-keys";
import { ProgramId, V4HSiteId } from "@/data/common/ids";
import { SiteProgramOverview } from "@/domains/v4b/program/program.types";

export interface IDeleteProgramCommand {
  siteId: V4HSiteId;
  programId: ProgramId;
}

export function useDeleteSiteProgramMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: InternalMutationKeys.deleteSiteProgram(),
    mutationFn: async ({ siteId, programId }: IDeleteProgramCommand) => {
      const response = await KiliApi.deleteProgram(undefined, { params: { programId } });

      queryClient.setQueryData<SiteProgramOverview[]>(SitesQueryKeys.programs(siteId), (oldValue) => {
        return oldValue?.filter((program) => {
          return program.id !== programId;
        });
      });

      queryClient.removeQueries({
        exact: true,
        queryKey: SitesQueryKeys.programDetails(siteId, programId),
      });

      return response;
    },
    retry: false,
  });
}
